export type StepsType = {
  id: number;
  name: string;
  skipable: boolean;
  attributeIdentifier?: string[];
};

export const configuratorSteps: StepsType[] = [
  {
    id: 1,
    name: 'valve',
    skipable: false,
    attributeIdentifier: [
      'EGTF_1111__STRING',
      'EF022461__STRING',
      'EF022666__STRING',
      'EF023191__STRING',
      'EF020007__STRING',
      'EF000443__STRING',
      'EF024700__STRING',
      'EF024700_EGTF_3605__STRING',
      'EF023840__STRING',
    ],
  },
  {
    id: 2,
    name: 'actuator',
    skipable: false,
    attributeIdentifier: [
      'EF020233__STRING',
      'EF021858__STRING',
      'EF004663__STRING',
      'EF000462__STRING',
    ],
  },
  {
    id: 3,
    name: 'monitoring',
    skipable: true,
    attributeIdentifier: [
      'EGTF_3734__STRING',
      'EF002656__STRING',
      'EF000854__STRING',
      'EF021858__STRING',
    ],
  },
  {
    id: 4,
    name: 'solenoid',
    skipable: true,
    attributeIdentifier: [
      'BRAND__STRING',
      'EF000104__STRING',
      'EF004663__STRING',
    ],
  },
  {
    id: 5,
    name: 'service',
    skipable: false,
  },
  {
    id: 6,
    name: 'overview',
    skipable: false,
  },
];
